import flagsmith from 'flagsmith'
import { flags } from 'src/boot/flagsmith'

export function useFlagsmith() {
  return {
    hasFeature: (key: string) => !!flags.value[key]?.enabled,
    getValue: (key: string) => flags.value[key]?.value ?? null,
    identify: (userId: string, traits?: Record<string, string | number | boolean>) =>
      flagsmith.identify(userId, traits),
    logout: () => flagsmith.logout(),
    flagsmith,
  }
}
